var map = {
	"./AED.jpg": 158,
	"./AUD.jpg": 159,
	"./BRL.jpg": 160,
	"./CAD.jpg": 161,
	"./CHF.jpg": 162,
	"./CNH.jpg": 163,
	"./CNY.jpg": 164,
	"./DKK.jpg": 165,
	"./EUR.jpg": 166,
	"./FJD.jpg": 167,
	"./GBP.jpg": 168,
	"./HKD.jpg": 169,
	"./IDR.jpg": 170,
	"./INR.jpg": 171,
	"./JPY.jpg": 172,
	"./KHR.jpg": 173,
	"./KRW.jpg": 174,
	"./LAK.jpg": 175,
	"./LKR.jpg": 176,
	"./MXN.jpg": 177,
	"./MYR.jpg": 178,
	"./NOK.jpg": 179,
	"./NZD.jpg": 180,
	"./PGK.jpg": 181,
	"./PHP.jpg": 182,
	"./RUB.jpg": 183,
	"./SEK.jpg": 184,
	"./SGD.jpg": 185,
	"./THB.jpg": 186,
	"./TWD.jpg": 187,
	"./USD.jpg": 188,
	"./VND.jpg": 189,
	"./ZAR.jpg": 190
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 114;